const n = (t) => {
  if (!t.current) return;
  const e = t.current.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );
  e.length > 0 && e[0].focus();
};
export {
  n as focusFirstElement
};
//# sourceMappingURL=index.es553.js.map
